import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import thePackage from '../../package.json';
@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
	title = 'app';
	readonly appVersion = thePackage.version;

	constructor(private readonly titleService: Title) {}

	ngOnInit(): void {
		this.titleService.setTitle('OHI Returns Portal');
		(window as Window & { __APP_VERSION__?: string }).__APP_VERSION__ = this.appVersion;
		console.info(`[ReturnsPortalApp] Version ${this.appVersion}`);
		this.prefetchLikelyRoutes();
	}

	private prefetchLikelyRoutes(): void {
		const warmup = () => {
			void import('./shipment-setup/shipment-setup.component');
			void import('./links/links.component');
		};

		const requestIdle = (
			window as Window & {
				requestIdleCallback?: (callback: () => void) => number;
			}
		).requestIdleCallback;

		if (requestIdle) {
			requestIdle(warmup);
			return;
		}

		setTimeout(warmup, 1000);
	}
}
